'use strict';

var SpillDtdDowPaxGapAggregationFactory = function SpillDtdDowPaxGapAggregationFactory(DataAggregationFactory) {
  function SpillDtdDowPaxGapAggregation() {
    DataAggregationFactory.call(this, 'rom-analysis-flattened-services-mode', 'spill-dtd-dow-pax-gap');
  }
  SpillDtdDowPaxGapAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  SpillDtdDowPaxGapAggregation.constructor = SpillDtdDowPaxGapAggregation;
  SpillDtdDowPaxGapAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  SpillDtdDowPaxGapAggregation.prototype.aggregate = function (data, metricsKeys) {
    var aggregatedSpillPaxGap = [],
      map = [];
    var self = this;
    for (var i = 0; i < data.length; i++) {
      var record = data[i];
      var daysToDeparture = record.daysToDeparture;
      var mapDtdRangeIndex = map.indexOf(daysToDeparture);
      var dow = record.dow;
      var spillPaxGap = {};
      if (mapDtdRangeIndex === -1) {
        spillPaxGap[dow] = self.getMetricValue(record.spillPaxGap, metricsKeys, true);
        spillPaxGap.daysToDeparture = daysToDeparture;
        aggregatedSpillPaxGap.push(spillPaxGap);
        map.push(daysToDeparture);
      } else if (!aggregatedSpillPaxGap[mapDtdRangeIndex][dow]) {
        aggregatedSpillPaxGap[mapDtdRangeIndex][dow] = self.getMetricValue(record.spillPaxGap, metricsKeys, true);
      } else {
        aggregatedSpillPaxGap[mapDtdRangeIndex][dow] += self.getMetricValue(record.spillPaxGap, metricsKeys, true);
      }
    }
    return aggregatedSpillPaxGap;
  };
  return SpillDtdDowPaxGapAggregation;
};
SpillDtdDowPaxGapAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory'];
module.exports = SpillDtdDowPaxGapAggregationFactory;